import * as React from 'react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import userContext from '../../Context/UserContext';
import { ClienteDTO } from '../../DTOs/ClienteDTO';
import { UsuarioLogadoDTO } from '../../DTOs/UsuarioLogadoDTO';
import api from '../../service/api';
import { ContainerFlutuante, Tabela } from './styles';

const ListaClientesVen: React.FC = () => {
  const [clientes, setClientes] = useState<ClienteDTO[]>([]);
  const currentlyUser = useContext(userContext);

  const EscolheCliente = useCallback((cliente: ClienteDTO): void => {

    let usuarioCopia: UsuarioLogadoDTO = { ...currentlyUser.user };

    usuarioCopia.Codcliente = cliente.Codcliente;
    usuarioCopia.Nomcliente = cliente.Nomcliente;
    usuarioCopia.Codempresacli = cliente.Codempresacli;
    usuarioCopia.Codempresa = cliente.Codempresa;
    usuarioCopia.Codalmoxarifado = cliente.Codalmoxarifado;

    localStorage.setItem('@VersaB2B:login', JSON.stringify(usuarioCopia));
    currentlyUser.onLogin(usuarioCopia);
  }, [currentlyUser.user]);


  useEffect(() => {
    if (currentlyUser.user.Codvendedor) {
      api.get(`api/cliente/vendedor/${currentlyUser.user.Codvendedor}`).then((response) => {

        // Desestrutura o objeto da API com somente os campos necessários na interface
        // e formata o valor para exibição
        const clientes: ClienteDTO[] = response.data;
        // Seta os produtos no state para usar na página
        setClientes(clientes);
      });
    }
  }, []);

  return (
    <ContainerFlutuante>
      <Tabela>
        <thead>
          <tr>
            <th>Código</th>
            <th>Nome</th>
            <th>Cnpj</th>
          </tr>
        </thead>
        <tbody>
          {clientes?.map((item: ClienteDTO, index: any) => {
            return (
              <tr key={index}>
                <td>{item.Codcliente}</td>
                <td><Link to="/" onClick={() => {
                  return EscolheCliente(item);
                }}>{item.Nomcliente}</Link></td>
                <td>{item.Cgccpf}</td>
              </tr>
            )
          })}
        </tbody>
      </Tabela>
    </ContainerFlutuante>
  )
};

export default ListaClientesVen;

